// Autogenerated file
export const popUpStatusesEnum = {
    Draft: "Draft",
    Active: "Active",
    Archived: "Archived",
};
export const popUpStatuses = [
    { label: "Черновик", value: "Draft" },
    { label: "Активный", value: "Active" },
    { label: "В архиве", value: "Archived" },
];
